import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExternalSearchResponse } from '../models/external-search.model';

// Recherche chez les réseaux d'affiliation (index des flux Awin, Amazon, Rakuten, CJ, Tradedoubler), quand aucun deal PromoDeep ne correspond
@Injectable({
  providedIn: 'root'
})
export class ExternalSearchService {

  constructor(private httpClient: HttpClient) { }

  search(query: string): Observable<ExternalSearchResponse> {
    return this.httpClient.get<ExternalSearchResponse>(environment.host + '/external-search', { params: { q: query } });
  }
}
